import { useGetListBankAccountProvider } from "../../api/bankAccount";

export const useBankAccountManagementProvider = (
  companyId: number,
  params: { start: number; end: number },
  name?: string,
  currencyId?: number
) => {
  const {
    data = {
      data: {
        data: { total: 0, pageSize: 10, page: 1, totalPages: 1, items: [] },
      },
    },
    isLoading,
    refetch,
  } = useGetListBankAccountProvider({
    companyId,
    ...params,
    name,
    currencyId,
  });
  return { dataListBankAccountProvider: data.data.data, isLoading, refetch };
};
